import _Message from "@arco-design/web-react/es/Message";
import React from 'react';
export var enable = location.hostname !== 'arco.design';
export var isExternal = location.hostname === 'arco.design';
export default function EnableFeature(props) {
  var _a = props.hideWhenDisabled,
    hideWhenDisabled = _a === void 0 ? true : _a;
  var children = props.children;
  var extraProps = {};
  if (!enable) {
    if (hideWhenDisabled) {
      return null;
    }
    extraProps.onClick = function () {
      _Message.info('即将开放，敬请期待！');
    };
  }
  return React.Children.count(children) > 1 || !extraProps.onClick ? children : /*#__PURE__*/React.cloneElement(children, extraProps);
}